















import { UseDrillDownMenu } from "@/components/root/drilldown-menu/drilldown-menu.state";
import VirtualTable from "@/components/table/VirtualTable.vue";
import { EventBus } from "@/eventbus";
import { emptyFn } from "@/fp";
import { onBeforeUnmount, onMounted } from "@vue/composition-api";
import Vue from "vue";
import { PlaybookDataDescriptor } from "../data/model";
import { table_config } from "./instances-table.config";
import { get_menu_items_for_instance } from "./menu-items";
import InstanceTableRow from "./InstanceTableRow.vue";
export default Vue.extend({
  components: { VirtualTable },
  props: ["instances", "is_loading"],
  setup(_, { emit }) {
    const subs = {
      show_menu: emptyFn(),
      generate_script: emptyFn(),
    };
    onMounted(() => {
      subs.show_menu = EventBus.listen(
        "showMenu",
        async (payload: {
          instance: PlaybookDataDescriptor;
          event: MouseEvent;
        }) => {
          const selection_res = await UseDrillDownMenu().show({
            menu: get_menu_items_for_instance(payload.instance),
            event: payload.event,
          });
          if (selection_res.didUserSelectedAnAction) {
            emit("on_action", {
              action: selection_res.actionSelected,
              instance: payload.instance,
            });
          }
        }
      );

      subs.generate_script = EventBus.listen(
        "generate_script",
        (instance: PlaybookDataDescriptor) => {
          emit("on_action", {
            action: "run",
            instance,
          });
        }
      );
    });

    onBeforeUnmount(() => Object.values(subs).forEach((ubsub) => ubsub()));
    return {
      InstanceTableRow,
      table_config,
    };
  },
});
